export default {"src":"/_next/static/media/caret_left.ceb001c2.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};